export default function SectionHeading({ eyebrow, title, description, align = "left", light = false }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  const eyeColor = light ? "text-[#FFFFFF]" : "text-[#B22234]";
  const titleColor = light ? "text-white" : "text-[#0A3161]";
  const descColor = light ? "text-[#F5F5F7]/75" : "text-[#1F2937]";

  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {eyebrow && (
        <div className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""} mb-5`}>
          <div className={`h-px w-10 ${light ? "bg-[#FFFFFF]" : "bg-[#B22234]"}`} />
          <span className={`font-condensed uppercase tracking-[0.3em] text-xs ${eyeColor}`}>{eyebrow}</span>
          <div className={`h-px w-10 ${light ? "bg-[#FFFFFF]" : "bg-[#B22234]"}`} />
        </div>
      )}
      <h2 className={`font-display font-bold text-4xl md:text-5xl lg:text-6xl leading-[1.05] ${titleColor}`}>
        {title}
      </h2>
      {description && (
        <p className={`mt-6 text-lg leading-relaxed ${descColor}`}>{description}</p>
      )}
    </div>
  );
}
